//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
	  name: 'Pinput',
	  props: ['xName','xClass','xMsg','xPlaceholder','xType','xVal'],
   
	  data(){
	    return{
	    	val:this.xVal,
	    	seen:true,
	     	icon_eye:"icon-eye",
	    }
	  },
		methods: {
		 //处理手机号表单状态
			blur: function(){
				var me =this;
			    setTimeout(function(){
			       //显示字符
			    },1)
		  	},

			focus:function(){
	
			},
		  	onchange:function (){
		  		this.$emit('blur',this.val.trim());
		  	},
		  	onchange2:function (){
		  		if (this.val.length >16)
		  		{
			        this.val = this.val.substring(0,16);
			    }
		  		this.$emit('input',this.val.trim());
		  	},
		  	showpwd:function (){
		  		if(this.icon_eye == "icon-eye")
		  		{
		  			this.icon_eye="icon-eye-n";
		  			this.seen=!this.seen;
		  			this.$refs.child.focus();
		  		}
		  		else{
		  			this.icon_eye="icon-eye";
		  			this.seen=!this.seen;
		  			this.$refs.child.focus();
		  		}
		  	},

		},
}



// WEBPACK FOOTER //
// ./src/components/Pinput.vue